import { isString } from 'lodash';

const isEmptyString = (value) => isString(value) && value === '';

// noinspection JSUnusedGlobalSymbols
export default isEmptyString;
